import React from "react";
import IncidentDashboard from "./components/IncidentDashboard";
import { EQUIPMENT_MANAGEMENT_INCIDENT } from "../../constants/modules";
import { fetchEquipmentIncidentsByDepartment } from "./services/service";
import { IncidentDepartmentEnum } from "../../constants/incidents";

const EquipmentManagementIncident: React.FC = () => (
  <IncidentDashboard
    department={IncidentDepartmentEnum.EquipmentManagement}
    pageTitle="Incident Management"
    moduleKey={EQUIPMENT_MANAGEMENT_INCIDENT}
    fetchService={fetchEquipmentIncidentsByDepartment}
  />
);

export default EquipmentManagementIncident;
